"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(designated) {
    window.history.length > 1 ? window.history.back() : (window.location.href = designated);
}
exports.default = default_1;
